import { cn } from "../../../lib/utils.js";

interface LoadingStateProps {
  message: string;
  layout?: "page" | "panel";
}

export function LoadingState({ message, layout = "page" }: LoadingStateProps): React.JSX.Element {
  return (
    <div
      className={cn(
        "grid place-items-center justify-items-center gap-3 px-6 py-8",
        layout === "page" ? "min-h-screen" : "min-h-40",
      )}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div
        className="size-7 shrink-0 rounded-full border-2 border-border border-t-primary animate-[spin_0.8s_linear_infinite] motion-reduce:animate-none"
        aria-hidden="true"
      />
      <p className="m-0 text-[0.8125rem] text-muted">{message}</p>
    </div>
  );
}
